import { REMINDER_TYPES } from '@src/shared/types/reminder';
import type { TReminder } from '@src/shared/types/reminder';

/** Log rows for non-bulk (automated) reminders only. */
export const AUTOMATED_REMINDER_LOG_TYPES: TReminder['type'][] = [
  // REMINDER_TYPES.general,
  REMINDER_TYPES.specificDate,
  REMINDER_TYPES.programDateRelated,
  REMINDER_TYPES.ruleRelated,
  REMINDER_TYPES.otherRules,
  REMINDER_TYPES.dateRule,
];

export const BULK_REMINDER_TYPES: TReminder['type'][] = [
  REMINDER_TYPES.bulk,
  REMINDER_TYPES.bulkStage,
  REMINDER_TYPES.bulkLead,
  REMINDER_TYPES.bulkApplication,
];
